import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles/QuizResultPage.css";

export default function QuizResultPage() {
  const [quizResult, setQuizResult] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get quiz result from location state
    if (location.state && location.state.quizResult) {
      setQuizResult(location.state.quizResult);
    } else {
      // If no result data, redirect to home
      navigate("/home");
    }
  }, [location, navigate]);

  const handleReturnHome = () => {
    navigate("/home");
  };

  const handleRetryQuiz = () => {
    if (quizResult && quizResult.quiz) {
      navigate(`/home/quiz-page?quizeId=${quizResult.quiz.id}`);
    } else {
      navigate("/home");
    }
  };

  if (!quizResult) {
    return <div>Loading...</div>;
  }

  const isPassed = quizResult.passed;
  const scoreColor = isPassed ? "#1ca15f" : "#d32f2f";

  return (
    <div className="quiz-result-page">
      <div className="quiz-result-card">
        <h1 className="quiz-result-title">
          Quiz Results
        </h1>
        
        <div className="quiz-result-message" style={{ color: scoreColor }}>
          {isPassed ? "Congratulations! You passed the quiz." : "You didn't pass the quiz."}
        </div>
        
        <div className="quiz-result-percentage" style={{ color: scoreColor }}>
          {quizResult.percentageScore.toFixed(2)}%
        </div>
        
        <div className="quiz-result-details">
          <div className="quiz-result-detail">
            <span className="quiz-result-label">Quiz Title:</span>
            <span>{quizResult?.quiz?.title}</span>
          </div>
          
          <div className="quiz-result-detail">
            <span className="quiz-result-label">Your Score:</span>
            <span>{quizResult.totalScore} / {quizResult.maxPossibleScore}</span>
          </div>
          
          <div className="quiz-result-detail">
            <span className="quiz-result-label">Start Time:</span>
            <span>{new Date(quizResult.startTime).toLocaleString()}</span>
          </div>
          
          <div className="quiz-result-detail">
            <span className="quiz-result-label">End Time:</span>
            <span>{new Date(quizResult.endTime).toLocaleString()}</span>
          </div>
          
          <div className="quiz-result-detail">
            <span className="quiz-result-label">Status:</span>
            <span style={{ color: scoreColor, fontWeight: 600 }}>{isPassed ? "PASSED" : "FAILED"}</span>
          </div>
        </div>
        
        <div className="quiz-result-actions">
          <button onClick={handleRetryQuiz} className="quiz-result-button quiz-result-retry">
            Retry Quiz
          </button>
          
          <button onClick={handleReturnHome} className="quiz-result-button quiz-result-home">
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
}